import { HTMLText, Icon } from '@crossfit/ui'
import style from './style.module.scss'
import { Text, Header } from '@crossfit/design-system'
import lock from './Lock.svg'
import alert from './ec.svg'
import { useContext } from 'react'
import { SettingsContext } from 'components/Settings'
import {
  AffiliateCredentialStatus,
  AffiliateLicenseStatus,
  AffiliatePaymentStatus,
  Role,
} from 'types'
import { useSelector } from 'react-redux'
import { getAffiliate, getMyAffiliates } from 'store/selectors'

function Banner(props: {
  title: string
  description: string
  cta?: { url: string; text: string }
}) {
  return (
    <div className={style.bannerContainer}>
      <div className={style.bannerTitle}>
        <div className={style.iconContainer}>
          <img src={alert} className={style.bannerIcon} />
          <Text type='body' size='md' className={style.bannerTitle}>
            {props.title}
          </Text>
        </div>
        <Text type='body' size='sm' className={style.bannerDesc}>
          {props.description}
        </Text>
      </div>
      {props.cta && (
        <a className={style.cta} href={props.cta.url}>
          <Text type='button' size='md'>
            {props.cta.text}
          </Text>
          <Icon name='arrow-right' className={style.ctaIcon} />
        </a>
      )}
    </div>
  )
}

export default function LockedOutPage() {
  const { selectedAffiliate: affiliateDetail } = useSelector(getMyAffiliates)
  const settings = useContext(SettingsContext)

  return (
    <>
      {affiliateDetail?.roles.includes(Role.LOR) && (
        <>
          {affiliateDetail?.standingDetails?.credentialStatus ===
            AffiliateCredentialStatus.Expired && (
            <Banner
              title={
                settings.data.affiliateStanding.lockedOutBanners.credential
                  .headlineText
              }
              description={
                settings.data.affiliateStanding.lockedOutBanners.credential
                  .description
              }
              cta={{
                url: settings.data.affiliateStanding.lockedOutBanners.credential
                  .cta.url,
                text: settings.data.affiliateStanding.lockedOutBanners
                  .credential.cta.text,
              }}
            />
          )}
          {affiliateDetail?.standingDetails?.licenseStatus ===
            AffiliateLicenseStatus.Unsigned30Plus && (
            <Banner
              title={
                settings.data.affiliateStanding.lockedOutBanners.license
                  .headlineText
              }
              description={
                settings.data.affiliateStanding.lockedOutBanners.license
                  .description
              }
            />
          )}
          {affiliateDetail?.standingDetails?.paymentStatus ===
            AffiliatePaymentStatus.PastDue30Plus && (
            <Banner
              title={
                settings.data.affiliateStanding.lockedOutBanners.payment
                  .headlineText
              }
              description={
                settings.data.affiliateStanding.lockedOutBanners.payment
                  .description
              }
              cta={{
                url: settings.data.affiliateStanding.lockedOutBanners.payment
                  .cta.url,
                text: settings.data.affiliateStanding.lockedOutBanners.payment
                  .cta.text,
              }}
            />
          )}
        </>
      )}

      <div className={style.wrapper}>
        <div className={style.titleContainer}>
          <img src={lock} />
          <Header size='lg' as='h1' className={style.titleHeader}>
            {affiliateDetail?.roles.includes(Role.LOR)
              ? settings.data.affiliateStanding.lockedOutPage.lor.headlineText
              : settings.data.affiliateStanding.lockedOutPage.managerCoach
                  .headlineText}
          </Header>
        </div>
        <HTMLText className={style.description}>
          {affiliateDetail?.roles.includes(Role.LOR)
            ? settings.data.affiliateStanding.lockedOutPage.lor.description
            : settings.data.affiliateStanding.lockedOutPage.managerCoach
                .description}
        </HTMLText>
      </div>
    </>
  )
}
